import { Coupon } from "typing";
import { FC, useCallback } from "react";
import {
  ToastContextProps,
  buildTestIds,
  getDiscountMessage,
} from "application";
import {
  BoxCouponsContainer,
  CouponDiscount,
  CouponCardContainer,
  CouponCardContent,
  BoxCouponsTitle,
  CouponNameBold,
  BoxCouponsContent,
  CouponDiscountDescription,
  CouponDiscountWrapper,
  CouponNameWrapper,
  CopyCouponContainer,
  CopyCouponIcon,
  CopyCouponText,
  CouponTicketIcon,
  CouponTicketWrapper,
  CouponName,
  CouponTicketIconWrapper,
} from "./styles";

interface BoxCouponsProps {
  coupons: Coupon[];
  useToast: () => ToastContextProps;
}

const BoxCoupons: FC<BoxCouponsProps> = ({ coupons, useToast }) => {
  const { addToast } = useToast();

  const copyToClipboard = useCallback(
    (couponName: string) => {
      if (couponName) {
        navigator?.clipboard?.writeText(couponName);

        addToast({
          isNewToast: true,
          newToastTheme: "light",
          type: "success",
          title: "Cupom copiado!",
          description: `O cupom ${couponName} foi copiado!`,
        });
      }
    },
    [addToast]
  );

  return coupons?.length === 0 ? null : (
    <BoxCouponsContainer {...buildTestIds("box-coupons-container")}>
      <BoxCouponsContent {...buildTestIds("box-coupons-content")}>
        <BoxCouponsTitle {...buildTestIds("box-coupons-title")}>
          {coupons?.length === 1 ? "Cupom disponível" : "Cupons disponíveis"}
        </BoxCouponsTitle>
        {coupons?.map((coupon, index) => (
          <CouponCardContainer
            key={coupon?.couponName || `coupon-${index}`}
            {...buildTestIds(
              `coupon-card-container-${coupon.couponName}-${coupon.productId}`
            )}
          >
            <CouponCardContent
              {...buildTestIds(
                `coupon-card-content-${coupon.couponName}-${coupon.productId}`
              )}
            >
              <CouponDiscountWrapper
                {...buildTestIds(
                  `coupon-discount-wrapper-${coupon.couponName}-${coupon.productId}`
                )}
              >
                <CouponDiscount
                  {...buildTestIds(
                    `coupon-discount-${coupon.couponName}-${coupon.productId}`
                  )}
                >
                  {getDiscountMessage(coupon)}
                </CouponDiscount>
                <CouponDiscountDescription
                  {...buildTestIds(
                    `coupon-discount-description-${coupon.couponName}-${coupon.productId}`
                  )}
                >
                  * Disponível para produtos selecionados
                </CouponDiscountDescription>
              </CouponDiscountWrapper>
              <CouponNameWrapper
                {...buildTestIds(
                  `coupon-name-wrapper-${coupon.couponName}-${coupon.productId}`
                )}
              >
                <CouponTicketWrapper
                  {...buildTestIds(
                    `coupon-ticket-wrapper-${coupon.couponName}-${coupon.productId}`
                  )}
                >
                  <CouponName
                    {...buildTestIds(
                      `coupon-name-${coupon.couponName}-${coupon.productId}`
                    )}
                    couponNameLengthGreaterThanTen={
                      coupon?.couponName?.length > 10
                    }
                  >
                    <CouponNameBold
                      {...buildTestIds(
                        `coupon-name-bold-${coupon.couponName}-${coupon.productId}`
                      )}
                    >
                      {coupon?.couponName}
                    </CouponNameBold>
                  </CouponName>
                  <CouponTicketIconWrapper
                    {...buildTestIds(
                      `coupon-ticket-icon-wrapper-${coupon.couponName}-${coupon.productId}`
                    )}
                  >
                    <CouponTicketIcon />
                  </CouponTicketIconWrapper>
                </CouponTicketWrapper>
                <CopyCouponContainer
                  {...buildTestIds(
                    `copy-coupon-container-${coupon.couponName}-${coupon.productId}`
                  )}
                  onClick={() => copyToClipboard(coupon?.couponName)}
                >
                  <CopyCouponIcon />
                  <CopyCouponText
                    {...buildTestIds(
                      `copy-coupon-text-${coupon.couponName}-${coupon.productId}`
                    )}
                  >
                    copiar cupom
                  </CopyCouponText>
                </CopyCouponContainer>
              </CouponNameWrapper>
            </CouponCardContent>
          </CouponCardContainer>
        ))}
      </BoxCouponsContent>
    </BoxCouponsContainer>
  );
};

export { BoxCoupons };
